import { gql, useMutation } from '@apollo/client';

export function useRestoreProduct() {
  const [mutate, { loading, error }] = useMutation<
    { restoreProduct: { message: string } },
    { productId: number }
  >(gql`
    mutation ($productId: Int!) {
      restoreProduct(productId: $productId) {
        message
      }
    }
  `);

  function restoreProduct(productId: number) {
    return mutate({ variables: { productId }});
  }

  return {
    restoreProduct,
    error,
    loading,
  };
}
